export const getPayload = (token) => {
  var base64Url = token.split(".")[1];
  // console.log("base64Url", base64Url);

  var base64 = base64Url.replace("-", "+").replace("_", "/");

  return JSON.parse(window.atob(base64));
};
